import { Component, OnInit, Input } from '@angular/core';
import _ from 'lodash';

@Component({
	selector: 'pcm-timesheet-row-calculated',
	templateUrl: './timesheet-row-calculated.component.html',
	styleUrls: ['./timesheet-row-calculated.component.scss']
})
export class TimesheetRowCalculatedComponent implements OnInit {

	@Input() type = 'standard';
	@Input() hours = [];

	constructor() { }

	ngOnInit() {
	}

	totalHours(hours) {
		let total = 0;
		hours.forEach(hour => {
			total += Number(hour);
		});
		const totalRounded = total.toFixed(1);
		// console.log('TOTAL CALCULATED ROUNDED HOURS', totalRounded);
		return totalRounded;
	}

	getType() {
		let rowType = this.type;
		if (rowType === 'straighttime') {
			rowType = 'standard';
		}
		return _.upperFirst(rowType);
	}
}
